<template>
  <svg :width="size" :height="size" viewBox="0 0 26 26" fill="none" v-on="$listeners">
    <path d="M5.72615 16C5.2468 14.9807 4.99944 13.8783 5 12.7637C5 8.476 8.58154 5 13 5C17.4185 5 21 8.47716 21 12.7648C21.0004 13.8791 20.753 14.981 20.2738 16" :stroke="color" stroke-width="2" stroke-linecap="round"/>
    <path d="M13 1V2.2M25 13H23.8M2.2 13H1M21.484 4.51359L20.6356 5.36199M5.3644 5.36319L4.516 4.51479M16.0204 21.7672C17.2324 21.3748 17.7196 20.2648 17.8564 19.1488C17.8972 18.8152 17.6224 18.538 17.2864 18.538H8.7724C8.69035 18.5367 8.60895 18.5528 8.5336 18.5853C8.45825 18.6178 8.39066 18.6659 8.3353 18.7265C8.27994 18.7871 8.23808 18.8587 8.21248 18.9367C8.18688 19.0147 8.17812 19.0972 8.1868 19.1788C8.3212 20.2924 8.6596 21.1072 9.9436 21.7672M16.0204 21.7672H9.9436M16.0204 21.7672C15.8752 24.1012 15.2008 25.0252 13.0084 24.9988C10.6636 25.042 10.1236 23.8996 9.9436 21.7672" :stroke="color" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>


<script>
export default {
  name: 'IconLightbulb',

  props: {
    size: {
      type: String,
      default: '1em',
    },
    color: {
      type: String,
      default: 'currentColor',
    },
  },
};
</script>